import React from 'react';
export function LogoIcon({
  size = 48
}: {
  size?: number;
}) {
  return <svg width={size} height={size} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="drop-shadow-lg" data-id="element-294">
      {/* Background rounded square with 3D effect */}
      <defs data-id="element-295">
        <linearGradient id="bg3d" x1="0" y1="0" x2="120" y2="120" gradientUnits="userSpaceOnUse" data-id="element-296">
          <stop offset="0%" stopColor="#2a2a2a" data-id="element-297" />
          <stop offset="40%" stopColor="#1d1d1f" data-id="element-298" />
          <stop offset="100%" stopColor="#0a0a0a" data-id="element-299" />
        </linearGradient>
        <linearGradient id="shine" x1="0" y1="0" x2="80" y2="80" gradientUnits="userSpaceOnUse" data-id="element-300">
          <stop offset="0%" stopColor="white" stopOpacity="0.15" data-id="element-301" />
          <stop offset="50%" stopColor="white" stopOpacity="0.03" data-id="element-302" />
          <stop offset="100%" stopColor="white" stopOpacity="0" data-id="element-303" />
        </linearGradient>
        <linearGradient id="textTop" x1="60" y1="20" x2="60" y2="60" gradientUnits="userSpaceOnUse" data-id="element-304">
          <stop offset="0%" stopColor="#ffffff" data-id="element-305" />
          <stop offset="100%" stopColor="#b0b0b0" data-id="element-306" />
        </linearGradient>
        <linearGradient id="textBottom" x1="60" y1="62" x2="60" y2="100" gradientUnits="userSpaceOnUse" data-id="element-307">
          <stop offset="0%" stopColor="#999999" data-id="element-308" />
          <stop offset="100%" stopColor="#ffffff" data-id="element-309" />
        </linearGradient>
        <filter id="innerShadow" data-id="element-310">
          <feOffset dx="0" dy="2" data-id="element-311" />
          <feGaussianBlur stdDeviation="1.5" data-id="element-312" />
          <feComposite operator="out" in="SourceGraphic" data-id="element-313" />
          <feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.4 0" data-id="element-314" />
          <feBlend in2="SourceGraphic" data-id="element-315" />
        </filter>
        <filter id="textShadow" data-id="element-316">
          <feDropShadow dx="0" dy="1.5" stdDeviation="1" floodColor="#000" floodOpacity="0.5" data-id="element-317" />
        </filter>
      </defs>

      {/* 3D base shadow */}
      <rect x="4" y="6" width="112" height="112" rx="26" fill="#000" opacity="0.3" data-id="element-318" />

      {/* Main background */}
      <rect x="2" y="2" width="116" height="116" rx="26" fill="url(#bg3d)" data-id="element-319" />

      {/* Subtle border */}
      <rect x="2" y="2" width="116" height="116" rx="26" stroke="white" strokeOpacity="0.08" strokeWidth="1" fill="none" data-id="element-320" />

      {/* Shine overlay */}
      <rect x="2" y="2" width="116" height="116" rx="26" fill="url(#shine)" data-id="element-321" />

      {/* Divider line */}
      <line x1="30" y1="62" x2="90" y2="62" stroke="white" strokeOpacity="0.12" strokeWidth="0.8" data-id="element-322" />

      {/* LE text - top */}
      <text x="60" y="50" textAnchor="middle" fontFamily="Inter, system-ui, sans-serif" fontWeight="800" fontSize="34" letterSpacing="4" fill="url(#textTop)" filter="url(#textShadow)" data-id="element-323">
        LE
      </text>

      {/* AI text - bottom */}
      <text x="60" y="92" textAnchor="middle" fontFamily="Inter, system-ui, sans-serif" fontWeight="800" fontSize="34" letterSpacing="4" fill="url(#textBottom)" filter="url(#textShadow)" data-id="element-324">
        AI
      </text>

      {/* Top-left corner accent dot */}
      <circle cx="18" cy="18" r="3" fill="white" opacity="0.15" data-id="element-325" />
    </svg>;
}